/* Keep track of the scroll activities:
 * 'initial' is set when the component in created.
 * Intended state changes triggered by updates of props and state:
 *
 *   initial -> (with new activityid) -> toId -> noTarget
 *           -> (without activityid) -> toLatest -> noTarget
 *
 *   noTarget -> (number of activities increases) -> toLatest -> noTarget
 */
export enum ScrollTarget {
  noTarget = 0, // neutral state when no scrolling is ongoing.
  toId = 2,
  toInitialLatest = 3,
  toLatest = 4,
}
